import { render, staticRenderFns } from "./TerminalDetails.vue?vue&type=template&id=3e65e642"
import script from "./TerminalDetails.vue?vue&type=script&lang=ts"
export * from "./TerminalDetails.vue?vue&type=script&lang=ts"
import style0 from "./TerminalDetails.vue?vue&type=style&index=0&id=3e65e642&prod&lang=scss"
import style1 from "./TerminalDetails.vue?vue&type=style&index=1&id=3e65e642&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports